// extracted by mini-css-extract-plugin
export default {"wrapper":"Privacy_wrapper__BWtoB","logo":"Privacy_logo__MwiEt","alphabetList":"Privacy_alphabetList__PbPbC"};